import { Box, Typography } from '@mui/material';

function StoryBlock({ summary, story }) {
  if (!summary && !story) return null;

  return (
    <Box
      sx={{
        position: 'relative',
        mx: 'auto',
        maxWidth: '60ch',
        px: { xs: 2, sm: 4 },
        py: { xs: 4, sm: 5 },
        mb: { xs: 5, sm: 7, md: 9 },
      }}
    >
      <Typography
        variant="overline"
        sx={{
          display: 'block',
          color: 'primary.main',
          letterSpacing: '0.22em',
          fontWeight: 600,
          fontSize: '0.75rem',
          mb: 1.5,
          textAlign: 'center',
        }}
      >
        Historia
      </Typography>
      {summary && (
        <Typography
          sx={{
            fontFamily: 'var(--font-heading)',
            color: 'text.primary',
            fontSize: { xs: '1.35rem', sm: '1.55rem', md: '1.7rem' },
            fontWeight: 500,
            lineHeight: 1.35,
            textAlign: 'center',
            mb: story ? 2.5 : 0,
          }}
        >
          {summary}
        </Typography>
      )}
      {story && (
        <Typography
          sx={{
            color: 'text.secondary',
            fontSize: { xs: '0.95rem', sm: '1rem' },
            lineHeight: 1.75,
            textAlign: 'center',
          }}
        >
          {story}
        </Typography>
      )}
    </Box>
  );
}

export default StoryBlock;
